import React from 'react';
import { Button, Tag, Popconfirm } from 'antd';
import { DatasetFileVersion, DatasetFilters } from '../../../types/dataset';
import { getDatasetFileStatus } from '../../../lib/util/status';
import moment from 'moment';
import { Icon } from '@ant-design/compatible';
import { CustomLink } from '../../../components/CustomLink';
import { Shorten } from '../../../components/text/Shorten';
import { DateFilter, NameFilter, StatusFilter, TagFilter } from '../Filters';

export const getDatasetOverviewTableColumns = (
  onClickUrl: (datasetfile: DatasetFileVersion) => string,
  onDelete: (datasetfile: DatasetFileVersion) => any,
  filters: DatasetFilters,
  setFilters: (filters: any) => any
) => {
  return [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      sorter: {
        multiple: 1,
      },
      filterDropdown: () => <NameFilter filters={filters} setFilters={setFilters} />,
      filterIcon: () => <Icon style={{ color: filters.name ? '#1890ff' : undefined }} theme="filled" type="filter" />,
      render: (text: string, datasetfile: DatasetFileVersion) => (
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <CustomLink
            disabled={['PROCESSING', 'PREP_FINISHED'].includes(datasetfile.datasetFile.status)}
            onClickUrl={onClickUrl(datasetfile)}>
            {datasetfile.datasetFile.file_name}
          </CustomLink>
        </div>
      ),
    },
    {
      title: 'Date',
      key: 'time_created',
      dataIndex: 'time_created',
      filterDropdown: () => <DateFilter filters={filters} setFilters={setFilters} />,
      filterIcon: () => (
        <Icon style={{ color: filters.date.length ? '#1890ff' : undefined }} theme="filled" type="filter" />
      ),
      sorter: {
        multiple: 1,
      },
      render: (text: string, datasetFile: DatasetFileVersion) => (
        <span>{moment(datasetFile.datasetFile.timeCreated).format('ll HH:mm:ss')}</span>
      ),
    },
    {
      title: 'Tag',
      key: 'tag',
      dataIndex: 'tag',
      sorter: {
        multiple: 1,
      },
      filterIcon: () => <Icon style={{ color: filters.tag ? '#1890ff' : undefined }} theme="filled" type="filter" />,
      filterDropdown: () => <TagFilter filters={filters} setFilters={setFilters} />,
      render: (text: string, datasetfile: DatasetFileVersion) => {
        const tag = datasetfile.properties.tag || 'Unlabelled';
        return (
          <span>
            <Tag>
              <Shorten text={tag} digits={16} />
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      sorter: {
        multiple: 1,
      },
      filterIcon: () => (
        <Icon style={{ color: filters.status.length ? '#1890ff' : undefined }} theme="filled" type="filter" />
      ),
      filterDropdown: () => <StatusFilter filters={filters} setFilters={setFilters} />,
      render: (text: string, datasetfile: DatasetFileVersion) => {
        return (
          <span>
            <Tag color={getDatasetFileStatus(datasetfile).color}>{getDatasetFileStatus(datasetfile).label}</Tag>
          </span>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: DatasetFileVersion) => (
        <span>
          <Popconfirm
            title="Are you sure to delete this document?"
            onConfirm={() => onDelete(record)}
            okText="Yes"
            cancelText="No">
            <Button type="link" style={{ marginLeft: '20px' }}>
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];
};
